function setArrowOffset(carouselTrack) {
    var trackHeight = carouselTrack.offsetHeight;
    var carousel = carouselTrack.closest('.images-carousel');
    var arrowsNav = carousel.querySelector('.arrows');
    var prevArrow = arrowsNav.querySelector('.prev');
    var nextArrow = arrowsNav.querySelector('.next');

    var arrowHeight = prevArrow.offsetHeight;
    var offset = (trackHeight / 2) - (arrowHeight / 2);

    prevArrow.style.top = offset + 'px';
    nextArrow.style.top = offset + 'px';
}

function getFlexGap(element) {
    const styles = window.getComputedStyle(element);
    var gap = 0;

    if (styles) {
        var rawGap = styles.columnGap || styles.gap;
        if (rawGap === 'normal') {
            gap = 0;
        } else {
            gap = parseFloat(rawGap);
        }
    }
    
    return parseFloat(gap);
}

function enableTransformDrag(element, arrowsNav) {
    // if (element.dataset.initialized === 'true') return;
    // element.dataset.initialized = 'true';

    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    var isAnimating = false;
    var isDragging = false;
    var isAutoPlay = element.dataset.autoplay === '1' ? true : false;
    var speed = element.dataset.speed ? element.dataset.speed : 5;

    var autoPlayIntervalId = null;
    var startX = 0;
    var startY = 0;

    // var block = element.closest('[data-block-id]');
    // var blockId = block ? block.getAttribute('data-block-id') : 'default';
    // var storageKey = blockId + '-carousel-index';

    var currentTranslate = 0;
    var lastTranslate = 0;

    var itemWidth = 0;
    var itemGap = 0;
    var gapOffset = 0;
    var step = 0;
    var offsetMultiplier = 1;
    var initialOffset = 0;
    var dragThreshold = 5;

    var nextCloneIndex = 0;
    var prevCloneIndex = element.children.length - 1;

    var prevArrow = arrowsNav.querySelector('.prev');
    var nextArrow = arrowsNav.querySelector('.next');

    var firstItem = element.children[0];
    if (firstItem) {
        itemWidth = parseFloat(firstItem.getBoundingClientRect().width.toFixed(2));
        itemGap = getFlexGap(element);

        step = itemWidth + itemGap;

        offsetMultiplier = window.innerWidth < 768 ? 0.65 : 0;
        gapOffset = itemGap / 2;

        initialOffset = -((step * offsetMultiplier) - gapOffset);

        element.style.transform = 'translateX(' + initialOffset + 'px)';
        currentTranslate = initialOffset;
    }

    var secondItem = element.children[1];
    if (secondItem) {
        secondItem.classList.add('active');
        setActiveItemInfo(secondItem);
        isInitialLoad = false;
    }

    function snapToNearest(position) {
        var index = Math.round((position - initialOffset) / step);
        return (index * step) + initialOffset;
        // return (((position - initialOffset) / step) * step) + initialOffset;
    }

    function setActiveClassForSecondFromSnap(element, currentTranslate) {
        var items = element.children;
        if (items.length > 1) {
            Array.from(items).forEach(function(item) {
                item.classList.remove('active');
            });

            var snappedIndex = Math.round((currentTranslate - initialOffset) / step);
            snappedIndex = snappedIndex === 1 ? -1 : Math.abs(snappedIndex);
            
            var secondItemIndex = snappedIndex + 1;
            if (secondItemIndex < items.length) {
                var activeItem = items[secondItemIndex];
                activeItem.classList.add('active');
                
                setActiveItemInfo(activeItem);
            }

        }
    }

    function setActiveItemInfo(activeItem) {
        var carousel = activeItem.closest('.images-carousel');
        var info = carousel.querySelector('.images-carousel-item-info');
        info.classList.remove('active');

        var title = activeItem.getAttribute("data-title") || "";
        var description = activeItem.getAttribute("data-description") || "";
        
        var titleEl = carousel.querySelector('.carousel-title');
        var descEl = carousel.querySelector('.carousel-description');

        if (titleEl) titleEl.textContent = title;
        if (descEl) descEl.textContent = description;
        if (title || description) info.classList.add('active');

    }

    function updateTranslate(translateX, direction, rawTranslateX) {
        if (isAnimating) return;
        isAnimating = true;
        
        try {

            currentTranslate = translateX;

            var items = Array.from(element.children).filter(function (item) {
                return !item.classList.contains('dynamic-clone');
            });
            var realItemCount = items.length;

            var snappedIndex = Math.round((currentTranslate - initialOffset) / step);
                snappedIndex = snappedIndex === 1 ? -1 : Math.abs(snappedIndex);

            var isSecondToLast = snappedIndex >= realItemCount - 3;
            var isSecond = snappedIndex <= 0;

            if (direction === "next" && isSecondToLast) {
                var firstRealItem = items[nextCloneIndex];
                var clone = firstRealItem.cloneNode(true);
                
                clone.classList.add('dynamic-clone');
                element.appendChild(clone);
                nextCloneIndex++;

                if (nextCloneIndex >= realItemCount) {
                    nextCloneIndex = 0;
                }
            }

            if(direction === "prev" && isSecond) {
                var lastRealItem = items[prevCloneIndex];
                var clone = lastRealItem.cloneNode(true);
                clone.classList.add('dynamic-clone');

                currentTranslate = translateX - step;

                var adjustedTranslate = translateX - (step * 2);
                if(rawTranslateX) {
                    adjustedTranslate = rawTranslateX - step;
                }

                element.style.transition = "none";
                element.style.transitionDuration = '0s';
                element.style.transform = "translateX(" + (adjustedTranslate) + "px)";

                element.prepend(clone);
                prevCloneIndex--;

                if (prevCloneIndex < 0) {
                    prevCloneIndex = realItemCount - 1;
                }
                
                void element.offsetHeight;

                element.style.transition = "transform 0.6s ease-in-out";
                element.style.transform = "translateX(" + currentTranslate + "px)";

            } 
            
            if (!isSecondToLast || !isSecond) {

                element.style.transition = "transform 0.6s ease-in-out";
                element.style.transform = "translateX(" + currentTranslate + "px)";

            }
            
            setActiveClassForSecondFromSnap(element, currentTranslate);

        } finally {

            setTimeout( function() {
                element.style.transition = "";
                isAnimating = false;
            }, 600);

        }

    }

    function handleBrowserResize() {
        var firstItem = element.children[0];
        if (firstItem) {
            itemWidth = parseFloat(firstItem.getBoundingClientRect().width.toFixed(2));
            itemGap = getFlexGap(element);
        }

        step = itemWidth + itemGap;
        offsetMultiplier = window.innerWidth < 768 ? 0.65 : 0;
        initialOffset = -(step * offsetMultiplier) + (itemGap / 2);

        var activeItem = element.querySelector('.active');
        if (activeItem) {
            var index = Array.from(element.children).indexOf(activeItem) - 1;
            currentTranslate = initialOffset - (index * step);
            lastTranslate = currentTranslate;
        
            element.style.transition = "none";
            element.style.transform = "translateX(" + currentTranslate + "px)";
        }

        setActiveClassForSecondFromSnap(element, currentTranslate);
        setArrowOffset(element);
    }

    function handlePrevArrowClick() {
        stopAutoPlay();
        updateTranslate(currentTranslate + step, 'prev');
    }

    function handleNextArrowClick() {
        stopAutoPlay();
        updateTranslate(currentTranslate - step, 'next');
    }

    function handleNextAutoPlay() {
        updateTranslate(currentTranslate - step, 'next');
    }

    function handleItemClick(e) {

        stopAutoPlay();
        isDragging = false;
        hasMoved = false;
        
        var activeItem = getCurrentActiveItem();
        var linkElm = activeItem ? activeItem.querySelector('.custom-link') : null;
        
        if(!linkElm) return;

        var target = linkElm.getAttribute('target');
        var url = linkElm.hasAttribute('href') ? linkElm.getAttribute('href') : '';
        var video = linkElm.dataset.videoModal;
        var modal = linkElm.dataset.promoLink;

        if (video || modal) {
            return linkElm.click();
        }

        if (url) {
            e.stopPropagation();

            if(url.includes('mailto:')) {
                return window.location.href = url;
            }

            var a = document.createElement('a');
            a.href = url;
            a.target = target || '_self';
            a.rel = 'noopener noreferrer';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            a.remove();
        }
    }

    function getCurrentActiveItem() {
        var activeItem = element.querySelector('.images-carousel-item.active');
        return activeItem;
    }

    function onPointerDown(e) {
        if (isAnimating) return;

        isDragging = true;
        hasMoved = false;
        stopAutoPlay();

        startX = e.clientX;
        startY = e.clientY;

        element.style.transition = "";
        element.setPointerCapture(e.pointerId);
    }

    function onPointerMove(e) {
        if (!isDragging || e.pointerType === 'mouse' && e.buttons !== 1) return;
        
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;

        // Detect vertical scroll — allow native scrolling
        if (!hasMoved && Math.abs(dy) > Math.abs(dx)) {
            isDragging = false;
            element.releasePointerCapture(e.pointerId);
            return;
        }

        if (!hasMoved && Math.abs(dx) > dragThreshold) {
            hasMoved = true;
            element.classList.add('dragging');
        }
    
        if (!hasMoved) return;

        e.preventDefault();

        lastTranslate = currentTranslate + dx;

        var maxTranslate = -(element.scrollWidth - element.offsetWidth);
        var maxOverflow = itemWidth + itemGap;
        
        lastTranslate = Math.max(maxTranslate - maxOverflow, Math.min(lastTranslate, maxOverflow));
        element.style.transform = "translateX(" + lastTranslate + "px)";
    }

    function onPointerUp(e) {
        if (!isDragging) return;

        if (!hasMoved) {
            return handleItemClick(e);
        }
        
        var snappedTranslate = snapToNearest(lastTranslate);
        var direction = snappedTranslate > currentTranslate ? "prev" : "next";

        updateTranslate(snappedTranslate, direction, lastTranslate);

        isDragging = false;
        hasMoved = false;
        element.classList.remove('dragging');
    }

    function onTouchStart(e) {
        if (isAnimating) return;

        // if (typeof currentTranslate !== 'number' || isNaN(currentTranslate) || currentTranslate === 0) {
        //     var savedIndex = sessionStorage.getItem(storageKey);
        //     if (savedIndex !== null) {
        //         var index = parseInt(savedIndex);
        //         if(index <= 0 ) {
        //             index = index + 1;
        //         }
        //         currentTranslate = initialOffset - (index * step);
        //         lastTranslate = currentTranslate;
        //     }
        // }

        isDragging = true;
        hasMoved = false;
        stopAutoPlay();

        var touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;

        element.style.transition = "";
    }
      
    function onTouchMove(e) {
        if (!isDragging) return;
    
        var touch = e.touches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
    
        if (!hasMoved) {
            if (Math.abs(dy) > Math.abs(dx)) {
                isDragging = false;
                return;
            }
            if (Math.abs(dx) > dragThreshold) {
                hasMoved = true;
            }
        }
    
        if (hasMoved) {
            e.preventDefault();

            lastTranslate = currentTranslate + dx;
    
            var maxTranslate = -(element.scrollWidth - element.offsetWidth);
            var maxOverflow = itemWidth + itemGap;
            
            lastTranslate = Math.max(maxTranslate - maxOverflow, Math.min(lastTranslate, maxOverflow));
            element.style.transform = "translateX(" + lastTranslate + "px)";
        }
    }
      
    function onTouchEnd(e) {
        if (!isDragging) return;

        if (!hasMoved) {
            return handleItemClick(e);
        }

        var snappedTranslate = snapToNearest(lastTranslate, (itemWidth + itemGap));
        var direction = snappedTranslate > currentTranslate ? "prev" : "next";

        updateTranslate(snappedTranslate, direction, lastTranslate);

        isDragging = false;
        hasMoved = false;
        element.classList.remove('dragging');
    }

    function autoPlay() {
        if (!isAutoPlay) return;
    
        autoPlayIntervalId = setInterval(function () {
            if (!isDragging && !isAnimating) {
                handleNextAutoPlay();
            }
        }, (speed * 1000));
    }

    function stopAutoPlay() {
        if (autoPlayIntervalId) {
            clearInterval(autoPlayIntervalId);
            autoPlayIntervalId = null;
            isAutoPlay = false;
        }
    }

    function imageClick(e) {
        e.preventDefault();

        var activeItem = getCurrentActiveItem();
        var linkElm = activeItem ? activeItem.querySelector('.custom-link') : null;
        var url = linkElm.getAttribute('href');
        var video = linkElm.dataset.videoModal;
        var modal = linkElm.dataset.promoLink;

        if (!url && !video && !modal) {
            e.stopPropagation();
        }
    }

    prevArrow.addEventListener('click', handlePrevArrowClick);
    nextArrow.addEventListener('click', handleNextArrowClick);
    element.addEventListener('click', function(e) {imageClick(e)});

    if (!isTouchDevice) {
        element.addEventListener('pointerdown', function(e) { onPointerDown(e) }, { passive: true });
        element.addEventListener('pointermove', function(e) { onPointerMove(e) }, { passive: false });
        element.addEventListener('pointerup', function(e) { onPointerUp(e) });
    } else {
        element.addEventListener('touchstart', function(e) { onTouchStart(e) }, { passive: true });
        element.addEventListener('touchmove', function(e) { onTouchMove(e) }, { passive: false });
        element.addEventListener('touchend', function(e) { onTouchEnd(e) });
    }

    window.addEventListener('resize', handleBrowserResize);

    document.addEventListener('visibilitychange', function () {
        if (!document.hidden) {
            setTimeout( function() {
                handleBrowserResize();
            }, 50);
        }
    });
    
    autoPlay();
}

function clearSessionIfInCPApp() {
    try {
        var parentBodyId = window.parent.document.body.id;
    
        if (parentBodyId === 'cpApp') {
            sessionStorage.clear();
        }
    } catch (e) {
        console.warn('Cannot access parent document — likely due to cross-origin restrictions');
    }
}
 
var init = function () {
    
    var carousels = document.querySelectorAll('.images-carousel');

    carousels.forEach(function(carousel) {

        var track = carousel.querySelector('.images-carousel-track');
        var arrows = carousel.querySelector('.arrows');

        if (track && arrows) {
            setArrowOffset(track);
            enableTransformDrag(track, arrows);
        }

    });

    clearSessionIfInCPApp();
};

module.exports = {
  init: init
};